import React, { useState, useEffect } from 'react';
import TextDisplay from '../../Forms/TextDisplay/TextDisplay';
import SingleLineField from '../../Forms/SingleLineField/SingleLineField';
import TranslateTag from '../../../Utils/Local/TranslateTag';
import {FormatDatesToLocaleForExport} from '../../../Utils/Local/TransformDatesInJson';
import ErrorMessage from '../../General/ErrorMessage/ErrorMessage';
import { PrimaryButton } from '@fluentui/react';
import { connect } from 'react-redux';
import Post from '../../../Data/Post';

import './Export.css';

const Export = (props) => {

    const [errorMessage, setErrorMessage] = useState(""); 
    const [specimenTypeList, setSpecimenTypeList] = useState(); 
    const [specimenStateList, setSpecimenStateList] = useState(); 
    const [tagList, setTagList] = useState(); 
    const [organisationList, setOrganisationList] = useState(); 
    const [locationList, setLocationList] = useState(); 
    const [testList, setTestList] = useState(); 

    const changeHandler = (id, value) => {
        props.changeHandler(id, value);
    }

    const GetFieldInfo = (fields, field) => {
        const fieldInfo = fields.filter(f => f.Id == field);
        return fieldInfo.length > 0 ? fieldInfo[0].value : undefined; 
    }

    const fields = props.config.Columns[0].FormGroups[0].Fields;
    const organismId = GetFieldInfo(fields,"OrganismId");
    const specimenTypeId = GetFieldInfo(fields,"SpecimenTypeId");
    const specimenStateId = GetFieldInfo(fields,"SpecimenStateId");
    const tagId = GetFieldInfo(fields,"TagId");
    const organisationId = GetFieldInfo(fields,"OrganisationId");
    const locationId = GetFieldInfo(fields,"LocationId");
    const testId = GetFieldInfo(fields,"TestId");

    useEffect(() => {
        let list = props.lists.filter(l => l.Name.toLowerCase() === "specimentype");
        setSpecimenTypeList(list[0].Options.map((option) => { return {key: option.Key, text: option.Text, ParentKey: option.ParentKey}}));
        list = props.lists.filter(l => l.Name.toLowerCase() === "statelist");
        setSpecimenStateList(list[0].Options.map((option) => { return {key: option.Key, text: option.Text, ParentKey: option.ParentKey}}));
        list = props.lists.filter(l => l.Name.toLowerCase() === "tag");
        setTagList(list[0].Options.map((option) => { return {key: option.Key, text: option.Text, ParentKey: option.ParentKey}}));
        list = props.lists.filter(l => l.Name.toLowerCase() === "organisationlist");
        setOrganisationList(list[0].Options.map((option) => { return {key: option.Key, text: option.Text, ParentKey: option.ParentKey}}));
        list = props.lists.filter(l => l.Name.toLowerCase() === "locationlist");
        setLocationList(list[0].Options.map((option) => { return {key: option.Key, text: option.Text, ParentKey: option.ParentKey}}));
        list = props.lists.filter(l => l.Name.toLowerCase() === "directtestconfiglist");
        setTestList(list[0].Options.map((option) => { return {key: option.Key, text: option.Text, ParentKey: option.ParentKey}}));
    },[]);

    const GenerateExport = () => {
        const parameters = [ 
            { key: "exportprofileid", value: props.id },
            { key: "organismId", value: organismId },
            { key: "specimenTypeId", value: specimenTypeId },
            { key: "stateId", value: specimenStateId },
            { key: "tagId", value: tagId },
            { key: "organisationFilterId", value: organisationId },
            { key: "locationId", value: locationId },
            { key: "testId", value: testId },
            { key: "startDate", value: GetFieldInfo(fields,"StartDate") },
            { key: "endDate", value: GetFieldInfo(fields,"EndDate") }          
        ]
        const criteria = { Name: 'runexport', Parameters: parameters};
        Post('export/run', criteria, dataRetrievedSuccessfully, errorWhenRetrievingData);
    }

    const dataRetrievedSuccessfully = (data) => {

        data = FormatDatesToLocaleForExport(data);
        
        let csv = "";
        for (const row of data) {
            let csvRow = '\"' + row.replace(/\|/g, '","') + '\"' ;
            csv += csvRow + '\n';
        }

        // Generate CSV file for download.
        var hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = 'export_run.csv';
        hiddenElement.click();
        props.save(false);
    }

    const errorWhenRetrievingData = (error) => {
        setErrorMessage(error.data);
    }

    const errorCloseHandler = () => {
        setErrorMessage("");
    }

    const startDateConfig = { Id: 'StartDate', Type: 'date', Label: TranslateTag("@GenStaB@", props.language), Required: true, Placeholder: TranslateTag("@GenSel@", props.language) };
    const endDateConfig = { Id: 'EndDate', Type: 'date', Label: TranslateTag("@GenEnd@", props.language), Placeholder: TranslateTag("@GenSelA@", props.language), Required: true };
    const organismListConfig = { Id: "OrganismId", Type: 'organismlist', value: organismId, includeOrText: false, value: organismId };
    const specimenTypeConfig = { Id: 'SpecimenTypeId', Type: 'combobox', Label: TranslateTag('@SpeSpeB@', props.language), MultiSelect: true, OptionsName: 'SpecimenType', Options: specimenTypeList, value: specimenTypeId};
    const specimenStateConfig = { Id: 'SpecimenStateId', Type: 'combobox', Label: TranslateTag('@GenSta@', props.language), MultiSelect: true, OptionsName: 'statelist', Options: specimenStateList, value: specimenStateId};
    const tagConfig = { Id: 'TagId', Type: 'combobox', Label: TranslateTag('@GenTagA@', props.language), MultiSelect: true, OptionsName: 'tag', Options: tagList, value: tagId};
    const organisationConfig = { Id: 'OrganisationId', Type: 'picker', Label: TranslateTag('@GenOrg@', props.language), MultiSelect: true, OptionsName: 'OrganisatiopList', Options: organisationList, value: organisationId};
    const locationConfig = { Id: 'LocationId', Type: 'picker', Label: TranslateTag('@PatPatJ@', props.language), MultiSelect: true, OptionsName: 'LocationList', Options: locationList, value: locationId};
    const testConfig = { Id: 'TestId', Type: 'combobox', Label: TranslateTag('@GenTes@', props.language), MultiSelect: true, OptionsName: 'TestConfigList', Options: testList, value: testId};
    
    return (
        <div className="app-crafted-content">
            <div className='app-crafted-title'>{props.config.PageTitle}</div>
            <div className='app-crafted-headertext'>
                <TextDisplay text={props.config.Text}></TextDisplay>
            </div>
            <div className="export-formcolumn">
                <SingleLineField key="SpecimenState" config={specimenStateConfig} changeHandler={changeHandler}></SingleLineField>
                <SingleLineField key="SpecimenType" config={specimenTypeConfig} changeHandler={changeHandler}></SingleLineField>
                <SingleLineField key="OrganismList" config={organismListConfig} changeHandler={changeHandler} language={props.language}></SingleLineField>
                <SingleLineField key="StartDate" config={startDateConfig} changeHandler={changeHandler}></SingleLineField>                    
                <SingleLineField key="EndDate" config={endDateConfig} changeHandler={changeHandler}></SingleLineField>
                <SingleLineField key="Organisation" config={organisationConfig} changeHandler={changeHandler}></SingleLineField>
                <SingleLineField key="Location" config={locationConfig} changeHandler={changeHandler}></SingleLineField>
                <SingleLineField key="Tag" config={tagConfig} changeHandler={changeHandler}></SingleLineField>
                <SingleLineField key="Test" config={testConfig} changeHandler={changeHandler}></SingleLineField>
                <br /><br />
                <div className='export-button'>
                    <PrimaryButton
                        text={TranslateTag("@ExpRet@", props.language)}
                        onClick={() => {GenerateExport()}}
                    />
                </div>
                <div>
                    <br />
                    <ErrorMessage visible={errorMessage !== ""} dismissHandler={errorCloseHandler} error={errorMessage}></ErrorMessage>
                </div>
            </div>
        </div>
    )
};

const mapStateToProps = state => {
    return {
        lists: state.config.lists
    };
}

export default connect(mapStateToProps)(Export);
